export enum PaymentType {
  CREDIT_CARD = 'Credit Card',
  EXISTING_CREDIT_CARD = 'Existing Credit Card',
  PAY_PAL = 'PayPal',
  IDRAM = 'Idram',
  EASY_WALLET = 'EasyWallet',
  TELCELL = 'Telcell',
  INECO_PAY = 'InecoPay',
  APPLE_PAY = 'Apple Pay',
  GOOGLE_PAY = 'Google Pay',
  MY_PAY = 'Ameria Bank',
  FASTSHIFT= 'Fastshift'

}

export class PaymentTypeUtil {
  private static readonly ICONS_PATH = 'assets/payment-type/'

  public static getIconByType(type: PaymentType) {
    switch (type) {
      case PaymentType.CREDIT_CARD:
      case PaymentType.EXISTING_CREDIT_CARD:
        return `${this.ICONS_PATH}credit-card.svg`;
      case PaymentType.PAY_PAL:
        return `${this.ICONS_PATH}paypal.svg`
      case PaymentType.IDRAM:
        return `${this.ICONS_PATH}idram.svg`
      case PaymentType.EASY_WALLET:
        return `${this.ICONS_PATH}easy-wallet.svg`
      case PaymentType.TELCELL:
        return `${this.ICONS_PATH}telcell.svg`
      case PaymentType.INECO_PAY:
        return `${this.ICONS_PATH}ineco-pay.svg`
      case PaymentType.APPLE_PAY:
        return `${this.ICONS_PATH}apple-pay.svg`
      case PaymentType.GOOGLE_PAY:
        return `${this.ICONS_PATH}google-pay.svg`
      case PaymentType.MY_PAY:
        return `${this.ICONS_PATH}my-pay.svg`
      default:
        return "";
    }
  }

  public static getTranslationByType(type: PaymentType) {
    switch (type) {
      case PaymentType.APPLE_PAY:
        return 'payment.apple_pay';
      case PaymentType.CREDIT_CARD:
        return 'payment.pay_with_new_credit_card';
      case PaymentType.EASY_WALLET:
        return 'payment.easywallet';
      case PaymentType.EXISTING_CREDIT_CARD:
        return 'payment.existing_credit_card';
      case PaymentType.GOOGLE_PAY:
        return 'payment.google_pay';
      case PaymentType.IDRAM:
        return 'payment.idram';
      case PaymentType.INECO_PAY:
        return 'payment.inecopay';
      case PaymentType.TELCELL:
        return 'payment.telcell';
      case PaymentType.MY_PAY:
        return 'payment.ameria_bank';
      default:
        return '';
    }
  }
}
